import axios from "axios"
import { env } from '../constants'

/* LIST */
export const list = data => {
    const uri = `${env.startpoint}/admin/booking/list`
    const token = localStorage.getItem("token")
    const headers = { headers: { Authorization: `Bearer ${token}` } }
    return axios.post(uri, data, headers).then(response => response).catch(data => data.response)
}

/* ORGANIZATIONS — the points the filter of the records is narrowed down by */
export const organizations = () => {
    const uri = `${env.startpoint}/admin/booking/organizations`
    const token = localStorage.getItem("token")
    const headers = { headers: { Authorization: `Bearer ${token}` } }
    return axios.get(uri, headers).then(response => response).catch(data => data.response)
}

/* GET — the whole card of one visit */
export const get = data => {
    const uri = `${env.startpoint}/admin/booking/get`
    const token = localStorage.getItem("token")
    const headers = { headers: { Authorization: `Bearer ${token}` } }
    return axios.post(uri, data, headers).then(response => response).catch(data => data.response)
}

/* STATUS — принять, завершить, отменить, не пришёл, вернуть в работу */
export const status = data => {
    const uri = `${env.startpoint}/admin/booking/status`
    const token = localStorage.getItem("token")
    const headers = { headers: { Authorization: `Bearer ${token}` } }
    return axios.post(uri, data, headers).then(response => response).catch(data => data.response)
}

/* TIME — the visit is moved to another hour */
export const time = data => {
    const uri = `${env.startpoint}/admin/booking/time`
    const token = localStorage.getItem("token")
    const headers = { headers: { Authorization: `Bearer ${token}` } }
    return axios.post(uri, data, headers).then(response => response).catch(data => data.response)
}
